import React from "react"
import styled from "styled-components"
import media from "styles/media"
import colors from "styles/colors"
import text from "styles/text"
import { ReactComponent as XCheckMark } from "images/XCheckMark.svg"
import { ReactComponent as Checkmark } from "images/Checkmark.svg"
const Comparison = ({ content }) => {
  const listOne = content?.sideOneList?.map(list => (
    <ListItemDiv>
      <XCheckIcon />
      <ListBody>{list.listItem}</ListBody>
    </ListItemDiv>
  ))
  const listTwo = content?.sideTwoList?.map(list => (
    <ListItemDiv>
      <CheckmarkIcon />
      <ListBody>{list.listItem}</ListBody>
    </ListItemDiv>
  ))
  return (
    <Wrapper>
      <CompareOption>
        <ListHeader>{content?.sideOneHeader}</ListHeader>
        <ListContainer>{listOne}</ListContainer>
      </CompareOption>
      <CompareOption>
        <ListHeader>{content?.sideTwoHeader}</ListHeader>
        <ListContainer>{listTwo}</ListContainer>
      </CompareOption>
    </Wrapper>
  )
}

export default Comparison
const ListBody = styled.p`
  ${text.bodyLg}
`
const CheckmarkIcon = styled(Checkmark)`
  width: 2.5vw;
  height: 2.5vw;
  ${media.fullWidth} {
    width: 36px;
    height: 36px;
  }

  ${media.tablet} {
    width: 4.317vw;
    height: 4.317vw;
  }

  ${media.mobile} {
    width: 9.6vw;
    height: 9.6vw;
  }
`
const XCheckIcon = styled(XCheckMark)`
  width: 2.5vw;
  height: 2.5vw;
  ${media.fullWidth} {
    width: 36px;
    height: 36px;
  }

  ${media.tablet} {
    width: 4.317vw;
    height: 4.317vw;
  }

  ${media.mobile} {
    width: 9.6vw;
    height: 9.6vw;
  }
`
const ListItemDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 1.111vw;
  ${media.fullWidth} {
    gap: 16px;
  }

  ${media.tablet} {
    gap: 1.918vw;
  }

  ${media.mobile} {
    gap: 4.267vw;
  }
`
const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.389vw;
  ${media.fullWidth} {
    gap: 20px;
  }

  ${media.tablet} {
    gap: 2.398vw;
  }

  ${media.mobile} {
    gap: 5.333vw;
  }
`
const ListHeader = styled.p`
  ${text.bodyXLBold}
`
const CompareOption = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.389vw;
  ${media.fullWidth} {
    gap: 20px;
  }

  ${media.tablet} {
    gap: 2.398vw;
  }

  ${media.mobile} {
    gap: 5.333vw;
  }
`
const Wrapper = styled.div`
  display: flex;
  gap: 2.778vw;
  ${media.fullWidth} {
    gap: 40px;
  }

  ${media.tablet} {
    gap: 4.796vw;
  }

  ${media.mobile} {
    gap: 10.667vw;
    flex-direction: column;
  }
`
